import usingServiceAdvantage from './usingQuickServiceAdvantage';
import frequentlyAskedQuestions from './quickservice-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Quick Service POS',
      description: `Accelerate service, accelerate your business with Quick Service POS`,
    },
    zh: {
      title: '快捷服务',
      description: `Chowbus POS可以帮助快捷服务餐厅更快备餐，服务更多顾客`,
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommend Products for Quick Service Restaurants',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
